import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Data/AuthContext";

// Client-side gate only — it hides UI that the user cannot use. The backend
// re-checks the token and role on every request, which is what actually
// enforces access.
export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { isAuthenticated, isAdmin, isBootstrapping } = useAuth();
  const location = useLocation();

  if (isBootstrapping) return null;

  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
